<template>
  <div class="logo-wrapper">
    <svg viewBox="0 0 302 78" class="logo">

      <g transform="translate(-0.976825,-18)">
        <g
            v-for="(paths, i) in askLetters"
            :key="'ask-'+i"
            class="letter"
            :class="{ visible: textVisible }"
            :style="letterDelay(i, askLetters.length)"
        >
          <path v-for="(d, j) in paths" :key="j" fill="#caff01" :d="d"/>
        </g>
      </g>

      <g transform="translate(-84.1317,17.456674)">
        <g
            v-for="(paths, i) in bookmakerLetters"
            :key="'bm-'+i"
            class="letter"
            :class="{ visible: textVisible }"
            :style="letterDelay(i, bookmakerLetters.length)"
        >
          <path v-for="(d, j) in paths" :key="j" fill="#caff01" :d="d"/>
        </g>
      </g>

      <g
          class="icon-group"
          :class="{
          'icon-enter':   phase === 'icon-enter',
          'icon-settled': phase === 'icon-settled' || phase === 'text-in' || phase === 'done' || phase === 'text-out',
          'icon-exit':    phase === 'icon-exit',
          'icon-hidden':  phase === 'idle'
        }"
      >
        <g transform="matrix(0.69243971,0,0,0.69243971,-0.1330706,1.1520908)">
          <path fill="#caff01" d="M 65.309,5.5586
C 60.9535,5.613287 56.6293,6.15235 52.418,7.1524 42.051,9.6212 32.359,14.8946 24.551,22.6994 8.977,38.3044 3.477,61.3794 10.289,82.4764
c 0.0039,0.01953 0.01172,0.03516 0.01563,0.05469 0.06641,0.20312 0.16016,0.39844 0.26953,0.58203 0.02734,0.03906 0.05078,0.07813 0.07813,0.11719 0.11328,0.17188 0.25,0.33203 0.40234,0.47266 0.02344,0.02344 0.05078,0.04297 0.08203,0.06641 0.16406,0.14844 0.34766,0.27344 0.54688,0.37891
h 0.0039
c 0.12891,0.06641 0.26172,0.12109 0.39844,0.16797 10.75,3.4883 22.262,3.8398 33.156,1.0039 1.4844,-0.38672 2.375,-1.9023 1.9922,-3.3867 -0.38672,-1.4844 -1.9023,-2.375 -3.3867,-1.9883 -1.5352,0.39844 -3.082,0.72656 -4.6367,0.98828 -3.125,-5.082 -6.9297,-9.8828 -11.273,-14.234 -4.3438,-4.3438 -9.1641,-8.1641 -14.242,-11.293 1.793,-10.727 6.8477,-20.828 14.793,-28.793 7.9609,-7.9453 18.055,-12.996 28.773,-14.785 3.1211,5.0781 6.9336,9.8867 11.273,14.23 4.3477,4.3477 9.1484,8.1641 14.23,11.289 -0.51172,3.0664 -1.2891,6.0938 -2.3398,9.0508
l 0.0039,0.0039
c -0.51563,1.4414 0.23828,3.0312 1.6797,3.5469 1.4453,0.51172 3.0273,-0.24219 3.543,-1.6836 4.3516,-12.242 4.5273,-25.598 0.51562,-38.012
C 86.1593,10.23 86.15147,10.21047 86.13976,10.18703 86.11242,10.10109 86.07726,10.01906 86.0382,9.93703 85.99523,9.851092 85.95226,9.76515 85.90148,9.68312 85.86242,9.616714 85.82335,9.55031 85.77648,9.48781 85.75304,9.452654 85.72961,9.417498 85.70226,9.38625 85.67882,9.355 85.65148,9.327656 85.62804,9.296406 85.59288,9.257343 85.55773,9.222187 85.52257,9.183126 85.51867,9.179216 85.51085,9.171407 85.50694,9.167501 85.44835,9.108907 85.38975,9.050311 85.32725,8.995621 85.25694,8.937027 85.18663,8.882341 85.11241,8.831561
c -0.07422,-0.05078 -0.15234,-0.10156 -0.23047,-0.14844 -0.0039,0 -0.0078,0 -0.0078,-0.00391
C 84.71789,8.593273 84.55383,8.522961 84.38586,8.468271 84.29602,8.440927 84.21008,8.409677 84.12024,8.382333
h -0.0039 -0.0078
c -6.1797,-1.9766 -12.523,-2.9023 -18.797,-2.8203
z

m 0.97656,5.5391
c 5.0078,0.02344 10.062,0.75391 15.012,2.2188 1.7188,5.832 2.4297,11.863 2.1367,17.848 -3.8789,-2.5977 -7.5898,-5.6445 -10.984,-9.043 -3.3906,-3.3906 -6.4219,-7.0859 -9.0156,-10.957 0.94922,-0.04687 1.8984,-0.07031 2.8555,-0.06641
z

m -4.9492,19.141
h 0.0039
c -0.65234,0.05469 -1.2617,0.33984 -1.7266,0.80469
l -2.0977,2.1055 -2.0625,-2.0625
c -0.52344,-0.51953 -1.2344,-0.80859 -1.9688,-0.80469 -0.73828,-0.0039 -1.4453,0.28516 -1.9688,0.80469 -0.52734,0.51953 -0.82031,1.2305 -0.82031,1.9688 0,0.73828 0.29297,1.4492 0.82031,1.9688
l 2.0625,2.0625 -5.3477,5.3555 -2.0625,-2.0664 -0.0039,-0.0039
c -0.52344,-0.51562 -1.2305,-0.80078 -1.9688,-0.79688 -0.73437,-0.0039 -1.4453,0.28125 -1.9688,0.79688 -0.52344,0.52344 -0.82031,1.2305 -0.82031,1.9727 0,0.73828 0.29688,1.4453 0.82031,1.9688
l 2.0664,2.0664 -5.3594,5.3594 -2.0547,-2.0547
c -0.52344,-0.52734 -1.2305,-0.82031 -1.9727,-0.82031 -0.72656,0 -1.4258,0.28516 -1.9453,0.79688 -0.52344,0.52344 -0.82031,1.2305 -0.82031,1.9688 0,0.73828 0.29688,1.4492 0.82031,1.9688
l 2.0547,2.0625 -2.1172,2.1211
h 0.0039
c -1.0781,1.082 -1.0781,2.832 0,3.918 0.51953,0.52344 1.2266,0.81641 1.9648,0.81641 0.73828,0 1.4453,-0.29297 1.9648,-0.81641
l 2.1055,-2.1055 2.0625,2.0625
c 0.51953,0.51953 1.2305,0.81641 1.9688,0.81641 0.73438,0 1.4453,-0.29688 1.9648,-0.81641 1.0781,-1.0859 1.0781,-2.8359 0,-3.918
l -2.0742,-2.0664 5.3672,-5.3672 2.0625,2.0625
c 0.51953,0.52344 1.2266,0.81641 1.9648,0.81641 0.73828,0 1.4453,-0.29297 1.9688,-0.81641 1.0742,-1.082 1.0742,-2.832 0,-3.918
l -2.0664,-2.0742 5.3594,-5.3594 2.0625,2.0625
h -0.0039
c 0.52344,0.52734 1.2305,0.82031 1.9727,0.82031 0.73828,0 1.4453,-0.29297 1.9688,-0.82031 0.52344,-0.51953 0.81641,-1.2266 0.81641,-1.9688 0,-0.73828 -0.29297,-1.4453 -0.81641,-1.9688
l -2.0625,-2.0625 2.0977,-2.0977
c 0.52734,-0.52344 0.82031,-1.2305 0.82031,-1.9688 0,-0.7383 -0.29297,-1.4492 -0.82031,-1.9688 -0.58203,-0.58203 -1.3906,-0.87891 -2.2109,-0.80469
z

m 9.207,20.102
c -5.7109,0 -10.922,2.1914 -14.844,5.7734
l 0.0039,-0.0039
c -0.14062,0.10156 -0.27344,0.21484 -0.39062,0.33594 -0.03516,0.03906 -0.06641,0.08203 -0.09766,0.12109 -4.1367,4.0117 -6.7109,9.6211 -6.7109,15.812 0,6.25 2.6211,11.91 6.8242,15.934 0.0078,0.0078 0.01563,0.01563 0.02344,0.02344 3.9609,3.7812 9.3164,6.1094 15.195,6.1094 5.7383,0 10.98,-2.2148 14.906,-5.8359
v -0.0039
c 0.11719,-0.08984 0.22656,-0.1875 0.32422,-0.29688 0.03906,-0.03516 0.07422,-0.07422 0.10938,-0.11328 4.1289,-4.0156 6.6992,-9.625 6.6992,-15.812 0,-6.168 -2.5547,-11.754 -6.6562,-15.762 -0.04688,-0.05859 -0.09766,-0.11719 -0.15234,-0.17188 -0.11328,-0.11719 -0.23438,-0.22656 -0.36719,-0.32031 -3.9258,-3.5938 -9.1445,-5.7891 -14.863,-5.7891
z

m 0,5.5547
c 3.4062,0 6.5625,1.0234 9.1836,2.7773 -3.082,3.875 -4.7969,8.6992 -4.7969,13.711 0,5.0195 1.707,9.8477 4.7891,13.727 -2.6211,1.7578 -5.7734,2.7773 -9.1797,2.7773 -3.4023,0 -6.5586,-1.0234 -9.1797,-2.7773 3.082,-3.8789 4.7891,-8.7109 4.7891,-13.727 0,-5.0156 -1.7031,-9.8438 -4.7852,-13.719 2.6172,-1.75 5.7734,-2.7656 9.1719,-2.7656
z

m -57.512,5.6953
c 3.875,2.5938 7.5742,5.6328 10.965,9.0273 3.3945,3.3984 6.4453,7.0977 9.043,10.977 -6.0039,0.29297 -12.043,-0.42188 -17.863,-2.1445 -1.7383,-5.8906 -2.4336,-11.926 -2.1445,-17.859
z

m 44.289,0.91797
c 2.1133,2.8281 3.2773,6.2852 3.2773,9.875 0,3.5898 -1.1641,7.0469 -3.2812,9.8789 -2.0508,-2.75 -3.2617,-6.168 -3.2617,-9.8789 0,-3.7148 1.2148,-7.125 3.2656,-9.875
z

m 26.453,0.01172
c 2.0469,2.7461 3.2539,6.1562 3.2539,9.8633 0,3.7109 -1.2109,7.1289 -3.2617,9.8789 -2.1172,-2.832 -3.2812,-6.2891 -3.2812,-9.8789 0,-3.582 1.1719,-7.0352 3.2891,-9.8633
z"/>
        </g>
      </g>

    </svg>
  </div>
</template>

<script setup lang="ts">
import {ref, watch, onMounted} from 'vue'

const props = defineProps<{ isLoaded: boolean }>()
const emit = defineEmits<{ (e: 'animation-complete'): void }>()

type Phase = 'idle' | 'icon-enter' | 'icon-settled' | 'text-in' | 'done' | 'text-out' | 'icon-exit'

const phase = ref<Phase>('idle')
const textVisible = ref(false)

const askLetters: string[][] = [
  ["m 112.62229,48.455318 h -4.28718 V 42.651131 H 93.264009 v 5.804187 H 88.976825 V 36.632585 q 0,-2.5888 0.890415,-4.765371 0.890415,-2.17657 2.473375,-3.74304 1.58296,-1.566471 3.743042,-2.440397 2.160081,-0.873927 4.715903,-0.873927 h 9.66265 q 0.44521,0 0.84095,0.164893 0.39574,0.164891 0.69254,0.461696 0.29681,0.296805 0.4617,0.692545 0.16489,0.39574 0.16489,0.840948 z M 93.264009,38.363947 h 15.071101 v -9.266913 h -7.53555 q -0.19787,0 -0.832705,0.05771 -0.634832,0.05771 -1.467535,0.28856 -0.832703,0.230848 -1.756097,0.709034 -0.923393,0.478187 -1.698384,1.319133 -0.774991,0.840948 -1.277911,2.10237 -0.502919,1.261421 -0.502919,3.058741 z"],
  ["m 134.35502,42.436772 q 0,1.104774 -0.28032,1.986944 -0.28032,0.882171 -0.74201,1.549983 -0.4617,0.66781 -1.0718,1.137752 -0.6101,0.469942 -1.27791,0.766746 -0.66781,0.296806 -1.35211,0.436963 -0.6843,0.140158 -1.2944,0.140158 H 116.7281 v -4.287183 h 11.57539 q 0.87393,0 1.31913,-0.445208 0.44521,-0.445208 0.44521,-1.286155 -0.0824,-1.714873 -1.73136,-1.714873 h -6.64514 q -1.41806,0 -2.40741,-0.494676 -0.98935,-0.494675 -1.6077,-1.236688 -0.61834,-0.742012 -0.89041,-1.599449 -0.27207,-0.857437 -0.27207,-1.599449 0,-1.434558 0.51116,-2.415663 0.51116,-0.981106 1.28616,-1.591205 0.77499,-0.610099 1.68189,-0.882171 0.9069,-0.27207 1.69838,-0.27207 h 10.53658 v 4.287183 h -10.5036 q -0.32978,0 -0.51941,0.0742 -0.18962,0.0742 -0.28031,0.19787 -0.0907,0.123669 -0.10718,0.263827 -0.0165,0.140158 -0.0165,0.272071 0.0165,0.263827 0.0989,0.412229 0.0824,0.148403 0.20611,0.214359 0.12367,0.06596 0.28032,0.0742 0.15664,0.0083 0.30505,0.0083 h 6.64513 q 1.64892,0 2.80316,0.59361 1.15424,0.59361 1.86328,1.492269 0.70903,0.89866 1.03057,1.953967 0.32154,1.055306 0.32154,1.962211 z"],
  [
    "M 141.70918,48.455318 H 137.422 V 23.094977 h 4.28718 z",
    "m 158.29729,48.455318 h -6.18344 l -8.64032,-8.343519 q -0.72553,-0.659567 -0.67606,-1.648917 0.033,-0.461697 0.23909,-0.865681 0.20612,-0.403985 0.56888,-0.684301 l 7.83235,-6.315351 h 6.8595 l -10.09137,8.12916 z",
  ],
]

const bookmakerLetters: string[][] = [
  ["m 195.76068,43.26123 q 0,0.79148 -0.27208,1.698385 -0.27206,0.906904 -0.8904,1.681894 -0.61835,0.774991 -1.6077,1.294401 -0.98935,0.519408 -2.42391,0.519408 h -16.27481 q -0.46169,0 -0.85743,-0.164892 -0.39574,-0.164891 -0.68431,-0.453452 -0.28856,-0.28856 -0.45345,-0.6843 -0.16489,-0.39574 -0.16489,-0.857437 V 26.969932 q 0,-0.445208 0.16489,-0.840948 0.16489,-0.39574 0.45345,-0.692545 0.28857,-0.296805 0.68431,-0.461696 0.39574,-0.164893 0.85743,-0.164893 h 14.34558 q 0.79148,0 1.69838,0.280317 0.90691,0.280316 1.69014,0.89866 0.78324,0.618343 1.30265,1.607694 0.51941,0.98935 0.51941,2.423907 v 0.80797 q 0,1.137752 -0.37925,2.44864 -0.37925,1.31089 -1.22021,2.48162 0.72553,0.445208 1.36036,1.071797 0.63484,0.626588 1.11302,1.451047 0.47819,0.824458 0.7585,1.863275 0.28032,1.038818 0.28032,2.291995 z m -4.28718,-0.824458 q 0,-0.840948 -0.26383,-1.508759 -0.26382,-0.667811 -0.74201,-1.145998 -0.47819,-0.478185 -1.15425,-0.733767 -0.67605,-0.255583 -1.517,-0.255583 h -9.66265 v -4.320161 h 7.73342 q 0.84094,0 1.51701,-0.255582 0.67605,-0.255583 1.15423,-0.733769 0.47819,-0.478185 0.73377,-1.145997 0.25559,-0.667812 0.25559,-1.508758 v -0.80797 q 0,-0.923394 -0.89042,-0.923394 h -12.21848 v 15.071101 h 14.14771 q 0.11543,0 0.28032,-0.01649 0.16489,-0.01649 0.2968,-0.09893 0.13192,-0.08245 0.23085,-0.280316 0.0989,-0.19787 0.0989,-0.544142 z"],
  ["m 218.40031,42.436772 q 0,1.104774 -0.28032,1.986944 -0.28032,0.882171 -0.74201,1.549983 -0.4617,0.66781 -1.07179,1.137752 -0.61011,0.469942 -1.27791,0.766746 -0.66782,0.296806 -1.35212,0.436963 -0.6843,0.140158 -1.2944,0.140158 h -7.73342 q -0.89041,0 -1.94572,-0.313294 -1.0553,-0.313295 -1.95397,-1.030573 -0.89866,-0.717279 -1.50051,-1.863276 -0.60186,-1.145997 -0.60186,-2.811403 v -5.804187 q 0,-1.648917 0.60186,-2.794914 0.60185,-1.145998 1.50051,-1.863276 0.89867,-0.71728 1.95397,-1.030574 1.05531,-0.313293 1.94572,-0.313293 h 7.73342 q 1.64891,0 2.80316,0.59361 1.15424,0.59361 1.86327,1.492269 0.70904,0.89866 1.03058,1.953967 0.32154,1.055306 0.32154,1.962211 z m -4.28719,-5.771209 q 0,-0.890415 -0.4452,-1.319134 -0.44521,-0.428718 -1.28616,-0.428718 h -7.70044 q -0.85744,0 -1.30264,0.436963 -0.44522,0.436963 -0.44522,1.277911 v 5.804187 q 0,0.840947 0.44522,1.286155 0.4452,0.445208 1.30264,0.445208 h 7.70044 q 0.87393,0 1.30265,-0.445208 0.42871,-0.445208 0.42871,-1.286155 z"],
  ["m 241.43567,42.436772 q 0,1.104774 -0.28031,1.986944 -0.28032,0.882171 -0.74202,1.549983 -0.46169,0.66781 -1.07179,1.137752 -0.6101,0.469942 -1.27791,0.766746 -0.66781,0.296806 -1.35211,0.436963 -0.6843,0.140158 -1.2944,0.140158 h -7.73342 q -0.89042,0 -1.94572,-0.313294 -1.05531,-0.313295 -1.95397,-1.030573 -0.89866,-0.717279 -1.50051,-1.863276 -0.60186,-1.145997 -0.60186,-2.811403 v -5.804187 q 0,-1.648917 0.60186,-2.794914 0.60185,-1.145998 1.50051,-1.863276 0.89866,-0.71728 1.95397,-1.030574 1.0553,-0.313293 1.94572,-0.313293 h 7.73342 q 1.64891,0 2.80316,0.59361 1.15424,0.59361 1.86327,1.492269 0.70903,0.89866 1.03057,1.953967 0.32154,1.055306 0.32154,1.962211 z m -4.28718,-5.771209 q 0,-0.890415 -0.44521,-1.319134 -0.4452,-0.428718 -1.28615,-0.428718 h -7.70044 q -0.85744,0 -1.30265,0.436963 -0.4452,0.436963 -0.4452,1.277911 v 5.804187 q 0,0.840947 0.4452,1.286155 0.44521,0.445208 1.30265,0.445208 h 7.70044 q 0.87392,0 1.30264,-0.445208 0.42872,-0.445208 0.42872,-1.286155 z"],
  [
    "m 249.43292,48.455318 h -4.28718 V 23.094977 h 4.28718 z",
    "m 266.02103,48.455318 h -6.18344 l -8.64033,-8.343519 q -0.72552,-0.659567 -0.67605,-1.648917 0.033,-0.461697 0.23909,-0.865681 0.20611,-0.403985 0.56887,-0.684301 l 7.83236,-6.315351 h 6.8595 l -10.09138,8.12916 z",
  ],
  ["m 284.34049,48.455318 h -4.28718 V 36.632585 q 0,-0.840948 -0.44521,-1.277911 -0.44521,-0.436963 -1.31913,-0.436963 h -5.57335 v 13.537607 h -4.28717 V 32.75763 q 0,-0.445208 0.16488,-0.832703 0.16489,-0.387496 0.46171,-0.676056 0.2968,-0.28856 0.69254,-0.453452 0.39574,-0.164891 0.84094,-0.164891 h 7.73343 q 0.89041,0 1.91274,0.313293 1.02233,0.313294 1.94572,1.00584 v -1.319133 h 5.80419 q 0.6101,0 1.28615,0.140157 0.67606,0.140158 1.34387,0.436963 0.66781,0.296805 1.27791,0.766747 0.6101,0.469941 1.0718,1.137752 0.46169,0.667811 0.74201,1.541738 0.28032,0.873925 0.28032,1.9787 v 11.822733 h -4.28719 V 36.632585 q 0,-0.840948 -0.42048,-1.277911 -0.42046,-0.436963 -1.29439,-0.436963 h -3.85847 q 0.21436,0.79148 0.21436,1.714874 z"],
  ["m 316.32948,42.552196 q 0,0.890415 -0.31329,1.920988 -0.3133,1.030573 -1.01409,1.912744 -0.70079,0.88217 -1.83029,1.47578 -1.12952,0.59361 -2.74546,0.59361 h -7.73341 q -0.89042,0 -1.92099,-0.313294 -1.03058,-0.313295 -1.91275,-1.014084 -0.88217,-0.70079 -1.47578,-1.830297 -0.59361,-1.129508 -0.59361,-2.745447 0,-0.890415 0.3133,-1.929233 0.3133,-1.038818 1.01408,-1.920987 0.70079,-0.882171 1.8303,-1.475781 1.1295,-0.59361 2.74545,-0.59361 h 7.73341 v 4.089314 h -7.73341 q -0.87393,0 -1.35212,0.535897 -0.47818,0.535898 -0.47818,1.327378 0,0.840948 0.55238,1.310889 0.55239,0.469942 1.3109,0.469942 h 7.70043 q 0.87393,0 1.35211,-0.527654 0.47819,-0.527653 0.47819,-1.319133 v -5.985569 q 0,-0.840947 -0.5194,-1.335622 -0.51942,-0.494676 -1.3109,-0.494676 h -9.41531 v -4.072823 h 9.41531 q 0.89042,0 1.92099,0.313293 1.03058,0.313294 1.91275,1.014084 0.88217,0.70079 1.47577,1.830298 0.59362,1.129508 0.59362,2.745446 z"],
  [
    "m 324.34322,48.455318 h -4.28719 V 23.094977 h 4.28719 z",
    "m 340.93131,48.455318 h -6.18343 l -8.64033,-8.343519 q -0.72552,-0.659567 -0.67605,-1.648917 0.033,-0.461697 0.23909,-0.865681 0.20611,-0.403985 0.56888,-0.684301 l 7.83235,-6.315351 h 6.85949 l -10.09136,8.12916 z",
  ],
  ["m 362.51564,36.533649 q 0,0.890416 -0.31329,1.920989 -0.3133,1.030573 -1.01409,1.912743 -0.70079,0.882171 -1.83029,1.475781 -1.12951,0.59361 -2.74546,0.59361 h -7.73341 v -4.072825 h 7.73341 q 0.87393,0 1.35212,-0.535898 0.47818,-0.535897 0.47818,-1.327378 0,-0.840947 -0.53589,-1.319133 -0.5359,-0.478187 -1.29441,-0.478187 h -7.73341 q -0.87393,0 -1.35212,0.535899 -0.47818,0.535898 -0.47818,1.327378 v 5.985568 q 0,0.857436 0.53589,1.335623 0.5359,0.478186 1.32738,0.478186 h 7.70044 v 4.089313 h -7.73341 q -0.89042,0 -1.92099,-0.313294 -1.03058,-0.313295 -1.91275,-1.014084 -0.88217,-0.70079 -1.47578,-1.830297 -0.59361,-1.129508 -0.59361,-2.745447 v -6.018547 q 0,-0.890414 0.3133,-1.920987 0.31329,-1.030574 1.01409,-1.912744 0.70078,-0.88217 1.83029,-1.47578 1.1295,-0.59361 2.74545,-0.59361 h 7.73341 q 0.89042,0 1.92099,0.313293 1.03058,0.313294 1.91275,1.014084 0.88217,0.70079 1.47578,1.830298 0.59361,1.129508 0.59361,2.745446 z"],
  ["m 380.99999,34.917711 h -9.64616 q -0.87393,0 -1.31913,0.436963 -0.44521,0.436963 -0.44521,1.277911 v 11.822733 h -4.28718 V 36.632585 q 0,-1.104775 0.28031,-1.9787 0.28032,-0.873927 0.75026,-1.541738 0.46995,-0.667811 1.08004,-1.137752 0.6101,-0.469942 1.27791,-0.766747 0.66781,-0.296805 1.35212,-0.436963 0.68429,-0.140157 1.27791,-0.140157 h 9.67913 z"],
]

const letterDelay = (index: number, total: number) => ({
  transitionDelay: textVisible.value
      ? `${index * 100}ms`
      : `${(total - 1 - index) * 60}ms`
})

let animationTimer: ReturnType<typeof setTimeout> | null = null
const clearTimer = () => {
  if (animationTimer) {
    clearTimeout(animationTimer);
    animationTimer = null
  }
}
const after = (ms: number, fn: () => void) => {
  animationTimer = setTimeout(fn, ms)
}

const pendingReverse = ref(false)

const TEXT_IN_DURATION = (bookmakerLetters.length - 1) * 100 + 400
const TEXT_OUT_DURATION = (bookmakerLetters.length - 1) * 60 + 400

const playForward = () => {
  clearTimer()
  phase.value = 'icon-enter'
  textVisible.value = false
  after(600, () => {
    phase.value = 'icon-settled'
    after(500, () => {
      phase.value = 'text-in'
      textVisible.value = true
      after(TEXT_IN_DURATION, () => {
        phase.value = 'done'
        if (pendingReverse.value) {
          pendingReverse.value = false
          playReverse()
        }
      })
    })
  })
}

const playReverse = () => {
  clearTimer()
  phase.value = 'text-out'
  textVisible.value = false
  after(TEXT_OUT_DURATION, () => {
    phase.value = 'icon-exit'
    after(700, () => {
      phase.value = 'idle'
      emit('animation-complete')
    })
  })
}

const SPLASH_KEY = 'askbookmaker_splash_shown'

onMounted(() => {
  if (sessionStorage.getItem(SPLASH_KEY)) {
    emit('animation-complete')
    return
  }
  sessionStorage.setItem(SPLASH_KEY, '1')
  playForward()
})

watch(() => props.isLoaded, (loaded) => {
  if (!loaded) return
  if (phase.value === 'done') {
    playReverse()
  } else {
    pendingReverse.value = true
  }
})
</script>

<style scoped>
.logo-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  z-index: 9999;
}

.logo {
  width: auto;
  height: 35%;
  max-width: 85vw;
}

.letter {
  opacity: 0;
  transition: opacity 0.4s ease;
}

.letter.visible {
  opacity: 1;
}

.icon-group {
  opacity: 0;
  transform: translateX(0);
  transition: opacity 0.5s ease,
  transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform, opacity;
}

.icon-group.icon-hidden {
  opacity: 0;
  transform: translateX(0);
}

.icon-group.icon-enter {
  opacity: 1;
  transform: translateX(115.6px);
  transition: opacity 0.5s ease,
  transform 0s;
}

.icon-group.icon-settled {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 0.3s ease,
  transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
}

.icon-group.icon-exit {
  animation: icon-zip-out 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes icon-zip-out {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  55% {
    opacity: 1;
    transform: translateX(115.6px);
  }
  100% {
    opacity: 0;
    transform: translateX(115.6px);
  }
}
</style>